import React from 'react';
import properties from '../../constants/Properties';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../../components/utils/SaveManager';
import recordedSoundUploadingUtils from '../../components/utils/RecordedSoundUploadingUtils';
import appParameters from '../../components/utils/AppParameters';
import configuration from '../../constants/Configuration';
import locales from '../../locales/LocalesManager';
import { showDescription, exitAlert } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import apiServiceUtils from '../utils/ApiServiceUtils';

const Button = React.createClass({
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var hostName = 'https://stage.creaza.com';
        var hrefLocation = '';

        if (configuration.IS_PROD())
            hostName = 'https://www.creaza.com';

        switch (this.props.index) {
            case 0: { // Tools
                hrefLocation = hostName + '/home/tools';
                break;
            }

            case 1: { // Activities
                hrefLocation = hostName + '/home/exercises';
                break;
            }

            case 2: { // Portfolio
                hrefLocation = hostName + '/portfolio#/myWork';
                break;
            }
        }

        if (recordedSoundUploadingUtils.isContentChanged()) {
            saveManager.hrefLocationForIOS = hrefLocation;

            const store = storeManager.getStore();
            store.dispatch(exitAlert(true));
        } else {
            window.location.href = hrefLocation;
        }
    },
    getCaption() {
        var caption;

        switch (this.props.index) {
            case 0: { // Tools
                caption = locales.getCaption('Tools', 'other');
                break;
            }

            case 1: { // Activities
                caption = locales.getCaption('Activities', 'other');
                break;
            }

            case 2: { // Portfolio
                caption = locales.getCaption('MyCreaza', 'other');
                break;
            }
        }

        return caption;
    },
    getLeftPos(buttonWidth) {
        var position;

        switch (this.props.index) {
            case 0: { // Tools
                position = 0;
                break;
            }

            case 1: { // Activities
                position = buttonWidth;
                break;
            }

            case 2: { // Portfolio
                position = this.props.windowWidth - properties.BROWSER_WIDTH - properties.INSERT_MENU_BUTTON_SIZE - buttonWidth;
                break;
            }
        }

        return position;
    },
    render () {
        const describeBoxWidth = properties.DESCRIBE_BOX_WIDTH;
        var freeLeftArea = (this.props.windowWidth - properties.BROWSER_WIDTH) / 2 - describeBoxWidth / 2;
        const width = freeLeftArea / 2;
        const height = properties.CLIPART_BUTTON_HEIGHT_OLD;
        var leftPos = this.getLeftPos(width);

        const buttonStyle = {
            position: 'absolute',
            left: leftPos,
            top: 0,
            width: width,
            height: height,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        var textAlignment = 'center';

        if (this.props.index == 1)
            textAlignment = 'left';

        const spanStyle = {
            position: 'absolute',
            top: 11,
            color: properties.BROWSER_SELECTED_COLOR,
            fontSize: 15,
            fontWeight: 'bold',
            width: width,
            textAlign: textAlignment,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        return (
            <div style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick}>
                <span style={spanStyle}>{this.getCaption()}</span>
            </div>
        );
    }
});

const DescribeBox = React.createClass({
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const store = storeManager.getStore();
        const state = storeManager.getState();
        const showDescriptionValue = !state.menu.showDescription;

        store.dispatch(showDescription(showDescriptionValue));
    },
    render () {
        var buttonWidth = 35;
        const width = properties.DESCRIBE_BOX_WIDTH;
        const height = properties.CLIPART_BUTTON_HEIGHT_OLD;
        var leftPos = (this.props.windowWidth - properties.BROWSER_WIDTH) / 2 - width / 2;

        const buttonStyle = {
            position: 'absolute',
            left: leftPos,
            top: 0,
            width: width,
            height: height,
            background: properties.BROWSER_SELECTED_COLOR,
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        const spanStyle = {
            position: 'absolute',
            top: 11,
            color: 'white',
            fontWeight: 'bold',
            fontSize: 15,
            width: width - buttonWidth,
            textAlign: 'center',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const eyeButton = {
            position: 'absolute',
            left: width - buttonWidth,
            top: 0,
            width: buttonWidth,
            height: height
        };

        const eyeIcon = {
            position: 'absolute',
            top: 10,
            left: 4,
            color: 'white'
        };

        return (
            <div className='describeItem' style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick}>
                <span className='describeItem' style={spanStyle}>{appParameters.navBarTitle}</span>

                <div className='describeItem' style={eyeButton}>
                    <i style={eyeIcon} className="fa fa-eye" />
                </div>
            </div>
        );
    }
});

export const NavigationBar = React.createClass({
    render () {
        const width = this.props.windowWidth;
        const height = properties.CLIPART_BUTTON_HEIGHT_OLD;
        var topBarHeight = apiServiceUtils.getNoInternetConnectionAlertHeight();

        const buttonStyle = {
            position: 'absolute',
            left: 0,
            top: topBarHeight,
            width: width,
            height: height,
            background: '#BDC5C8',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        var buttons = [];

        buttons.push(<Button index={0} windowWidth={this.props.windowWidth} key='navBar1'/>);
        buttons.push(<Button index={1} windowWidth={this.props.windowWidth} key='navBar2'/>);
        buttons.push(<Button index={2} windowWidth={this.props.windowWidth} key='navBar3'/>);
        buttons.push(<DescribeBox windowWidth={this.props.windowWidth} key='navBar4'/>);

        return (
            <div style={buttonStyle}>
                {buttons}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/NavigationBar.js
 **/